import NGODashboardContents from 'features/ngo/dashboard'
import React from 'react'

const NGODashboard = () => {
  return (
    <NGODashboardContents />
  )
}

export default NGODashboard